import React, { Component } from 'react'

export default class ForgotPassword extends Component {
  render() {
    return (
      <div>
        <h2>Forgot Password</h2>
        <form>
          <div>
            <label htmlFor="email">Email:</label>
            <input type="email" id="email" name="email" required />
          </div>
          <button type="submit">Send Password Reset Email</button>
        </form>
      </div>
    )
  }
}
